import createReactClass from 'create-react-class'
import React from 'react'
import SearchFormPanel from './search-form-panel'
import SearchResult from './search-result'

export default createReactClass({
  render () {
    return (
      <div className="search-panel">
        <div className="csc-panel">
          <div className="panel-body">
            <h4 className="card-title">Search Criteria</h4>
            <SearchFormPanel {...this.props} />
          </div>
        </div>
        <div className="csc-panel">
          <div className="panel-body">
            <h4 className="card-title">Search Results</h4>
            <SearchResult {...this.props}/>
          </div>
        </div>
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/search-page/search-panel.js